// extracted by mini-css-extract-plugin
export default {"container":"QE-z","modal":"RE-z","dimensions":"SE-z","brandName":"TE-z","productName":"UE-z","labelValue":"VE-z","recipientEmail":"WE-z","recommendedFit":"XE-z","hiddenField":"YE-z"};